
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//印地

export const lang ={
  Please_set_materialtype_in_product_page:"कृपया प्रत्येक उत्पाद के सामग्री प्रकार - तैयार उत्पाद - अर्ध-तैयार उत्पाद - सहायक उपकरण को संशोधित और सेट करने के लिए उत्पाद पृष्ठ पर जाएं।",
deleteAccount:"लॉग आउट",
deleteAccountWillDeleteAllData:"आपके खाते से लॉग आउट करने पर सारा डेटा हट जाएगा और आप लॉग इन करने में असमर्थ हो जाएंगे।",
backupDatabase:"बैकअप डेटाबेस",
restoreDatabase:"डेटाबेस पुनर्स्थापित करें",
materialtype:"सामग्री के प्रकार",
Manufacturing:"विनिर्माण संस्करण",
Professional:"व्यावसायिक संस्करण",
Standard:"मानक संस्करण",
product:"तैयार उत्पाद",
halfProduct:"अर्ध - पूर्ण उत्पाद",
components:"सामान",
Parent:"मूल घटक",
Children:"उप-सहायक उपकरण",
Level:"पदानुक्रम",
Timing:"समय",
PieceCount:"ठेका",
Wages:"वेतन",
InternalProcess:"आंतरिक प्रक्रियाएं",
ExternalProcess:"बाह्य प्रक्रिया",
ProceName:"प्रक्रिया नाम",
ProceIndex:"निष्पादन आदेश",
ChargeMan:"प्रधानाचार्य",
BillMethod:"बिलिंग विधि",
ConsumTime:"कार्य के घंटे",
Accessories:"सामान",
Assembly:"इकट्ठा",
materials:"सामग्री",
task:"काम",
process:"प्रक्रिया",
BOM:"बीओएम",
Production:"उत्पादन",
RestorePurchaseOneUse:"खरीदारी पुनर्स्थापित करें (एक उपयोगकर्ता (पिछली खरीदारी तक सीमित))",
buy_fail_try_again:"कृपया खरीदने के लिए दोबारा क्लिक करें",
Export:"निर्यात",
Date:"तारीख",
BankDetail:"बैंक विवरण",
Seller:"विक्रेता",
Buver:"क्रेता",
Currency:"मुद्रा",
CompanyName:"कंपनी का नाम",
ProformaInvoice:"प्रोफार्मा चालान",
Discount:"छूट",
PayStatus:"भुगतान की स्थिति",
ShippingStatus:"शिपिंग की स्थिति",
FreightType:"परिवहन प्रकार",
Shipping:"परिवहन",
Payment:"भुगतान",
Moneyname:"मुद्रा का नाम",
Tax:"करों",
Freight:"भाड़ा प्रभार",
Insurance:"बीमा",
Bankfee:"बैंक शुल्क",
Qc:"गुनवत्ता का परमाणन",
Exchangerate:"विनिमय दर",
Shippingnumber:"लदान संख्या",
ShipDate:"भेजने की तारीख",
Arrivedate:"पहुँचने की तारीख",
Grossweight:"कुल वजन",
CubicWeight:"घन भार",
Totalpackages:"पैकेजों की कुल संख्या",
Moneytype:"मुद्रा प्रकार",
Quotedate:"उद्धरण तिथि",
Validitydate:"वाजिब तारीख",
Paymentterm:"वेतन की समाप्ति",
Priceterm:"मूल्य निर्धारण अवधि",
DeliveryTerm:"डिलीवरी का समय",
BankName:"बैंक का नाम",
BankAddress:"बैंक पता",
SwiftCode:"बैंक का सांकेतिक अंक",
Review:"समीक्षा",
Signfor:"रसीद के लिए हस्ताक्षर करें",
Finance:"वित्त",
Receiver:"रिसीवर",
Business:"व्यापार",
ContactPerson:"संपर्क व्यक्ति",
Profit:"लाभ",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"कर्मचारियों को Google Chrome का उपयोग करना होगा। कृपया मुख्य सेवा कंप्यूटर एपीपी के सहायता पृष्ठ पर आईपी पता जांचें, और फिर लॉगिन खोलने के लिए अन्य कंप्यूटर ब्राउज़र के यूआरएल कॉलम में पता दर्ज करें",
newPassword:"नया पासवर्ड",
ForgetPassword:"पासवर्ड भूल जाओ",
ContactUs:"हमसे संपर्क करें/सुझाव दें",
Actualpay_should_big_then_shouldpay:"वास्तविक प्राप्तियाँ प्राप्य से अधिक नहीं हो सकतीं",
ShopAddress:"मेरे स्टोर का पता ऑर्डर देने के लिए क्यूआर कोड को स्कैन करें",
Submit:"जमा करना",
All:"सभी",
OrdernumExists:"ऑर्डर नंबर पहले से मौजूद है",
PermissionDenied:"अनुमति नहीं मिली",
StockTransfer:"स्टॉक अंतरण",
FromWarehouse:"गोदाम से बाहर स्थानांतरण",
ToWarehouse:"गोदाम में स्थानांतरण",
PleaseUseInWebBrowser:"कृपया Google Chrome में एक्सपोर्ट एक्सेल फ़ंक्शन का उपयोग करें",
PleasePrintInWebBrowser:"कृपया Google Chrome में प्रिंट फ़ंक्शन का उपयोग करें",
HistoryPrice:"ऐतिहासिक कीमत",
SerialNumber:"क्रम संख्या",
Please_Use_In_APP:"कृपया इसे कंप्यूटर सॉफ़्टवेयर में उपयोग करें",
Please_Purchase_In_APP:"कृपया एपीपी के भीतर खरीदारी करें, ब्राउज़र के भीतर नहीं",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"आप Postgresql डेटाबेस से कनेक्ट कर सकते हैं। आपका डेटा Postgresql डेटाबेस में संग्रहीत किया जाएगा। डिफ़ॉल्ट रूप से, आपको Postgresql डेटाबेस से कनेक्ट करने की आवश्यकता नहीं है। डिफ़ॉल्ट स्थानीय SQLite डेटाबेस है।",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Postgresql डेटाबेस से कनेक्ट करें, आपका डेटा Postgresql डेटाबेस में संग्रहीत किया जाएगा, और डेटा फिर से पढ़ा जाएगा",
Use_sqlite_data_will_store_in_local:"एसक्लाइट का उपयोग करके, डेटा स्थानीय मशीन पर संग्रहीत किया जाएगा",
UsePostgresqlDatabase:"पीजीएसक्यूएल डेटाबेस का उपयोग करना",
UseSqliteDatabase:"स्क्लाइट डेटाबेस का उपयोग करना",
DatabaseName:"नाम डेटाबेस",
Test_connect:"परीक्षण कनेक्शन",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"यदि उत्पाद में कोई रंग या आकार है, तो कृपया प्रारंभिक सूची के लिए 0 भरें। उत्पाद जोड़ने के बाद, खरीदारी में सूची दर्ज करें।",
my:"मेरा",
my_shop_qrcode_scan:"मेरे स्टोर का क्यूआर कोड ग्राहकों को ऑर्डर देने के लिए कोड को स्कैन करने की क्षमता प्रदान करता है। ग्राहक का मोबाइल फोन आपके कंप्यूटर के समान राउटर से जुड़ा होना चाहिए।",
ip:"आई पी",
port:"पत्तन",
orderstatus:"आदेश की स्थिति",
image:"चित्र",
Template:"खाका",
Please_select_a_excel_file:"कृपया एक फ़ाइल चुनें",
Please_select_only_one_excel_file:"केवल एक फ़ाइल का चयन किया जा सकता है",
Connect_Internet_Login_again:"इंटरनेट से कनेक्ट करें और खरीदने से पहले दोबारा लॉग इन करें",
productHasValidDate:'उत्पाद की एक वैध अवधि है',
productHasColor:'उत्पाद का रंग आकार है',
GeneralGoods:'सामान्य सामान',
Selected:'चुना गया',
RestorePurchase:'खरीद फिर से शुरू करें',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'इनवॉइसिंग एंटरप्राइज़ संस्करण 1 उपयोगकर्ताओं को स्थायी रूप से खरीदें',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'खरीद चालान एंटरप्राइज़ संस्करण उपयोगकर्ताओं और उपकरणों के लिए असीमित है',
Purchasing:'खरीदना ... कृपया धैर्यपूर्वक प्रतीक्षा करें ...',
Validdate:'वैधता अवधि',
Makedate:'उत्पादन की तारीख',
Batch:'जत्था',
CheckVersion:'संस्करण की जाँच करें',
Please_set_this_ip_address_on_App:'कृपया इस आईपी पते या कंप्यूटर के आईपी पते को एपीपी पर सेट करें।',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'इस कनेक्शन को अपने कंप्यूटर या मोबाइल ब्राउज़र में खोलें (समान WiFi कनेक्ट करें)',


CheckVersion: 'चेक संस्करण',
You_need_to_purchase: 'आपने अभी तक खरीदारी नहीं की है, कृपया WeChat को Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase: 'आप पहले ही खरीद चुके हैं',
New_version_available: 'एक नया संस्करण है',
Is_the_latest_version: 'नवीनतम संस्करण है',
    please:'कृप्या',
input:'इनपुट',
wrong:'गलत',
Verifycode:'कोड सत्यापित करें',
Upload:'अपलोड',
Download:'डाउनलोड',
You_need_to_purchase_to_continue_use:'उपयोग जारी रखने के लिए आपको खरीदारी करने की आवश्यकता है',
CheckBuy:'खरीद की जाँच करें',
Exists:'मौजूद',
NetworkUnavailable:'प्रसार अनुपलब्ध है',
Today:'आज',
Yesterday:'बिता कल',
ThisMonth:'इस महीने',
LastMonth:'पिछले महीने',
nickname:'निक नाम',
storeName:'स्टोर नाम',
BuyStandAlone:'स्टैंड-अलोन संस्करण खरीदें',
PermissionDenied:'अनुमति नहीं मिली',
Boss:'Boss',
    login:'लॉग इन करें',
operate:'प्रचालन',
register:'रजिस्टर',
username:'उपयोगकर्ता नाम',
password:'पारण शब्द',
User:'उपयोगकर्ता',
ok:'ठीक',
back:'वापस',
success:'सफलता',
fail:'असफल',
cancel:'रद्द करना',
add:'जोड़ना',
edit:'संपादित करें',
delete:'हटाना',
refresh:'ताज़ा करना',
close:'बंद करे',
cancel:'रद्द करना',
return:'वापसी',
ElinkInvoice:'लुप्त हो जाना',
Purchase:'खरीद फरोख्त',
BaseData:'आधार डेटा',
Sell:'बेचना',
PurchaseReturns:'खरीद रिटर्न',
SellReturns:'रिटर्न बेचते हैं',
Inventory:'इन्वेंटरी',
Statistics:'आंकड़े',
Receivable:'प्राप्य',
Payable:'देय',
Orders:'आदेश',
StockTransfer:'स्टाक ट्रान्स्फ़र',
StockRecall:'स्टॉक रिकॉल',
Customer:'ग्राहक',
Supplier:'प्रदायक',
Warehouse:'गोदाम',
Color:'रंग',
Size:'आकार',
Category:'वर्ग',
Category2:'CATEGORY2',
Product:'उत्पाद',
Account:'लेखा',
AccountType:'खाता श्रेणी',
Staff:'कर्मचारी',
typeone:'वर्ग',
typetwo:'उप श्रेणी',
ProductName:'उत्पाद का नाम',
Specification:'विशिष्टता',
Barcode:'बारकोड',
Buyprice:'मूल्य खरीदें',
Sellprice:'विक्रय मूल्य',
Wholesaleprice:'थोक मूल्य',
Currentstock:'वर्तमान स्टॉक',
Unit:'इकाई',
Initstock:'Init स्टॉक',
Parameter:'पैरामीटर',
Remark:'टिप्पणी',
Supplier:'प्रदायक',
Customer:'ग्राहक',
Staff:'कर्मचारी',
Receivable:'प्राप्य',
payable:'देय',
Receipts:'प्राप्तियां',
Paid:'भुगतान किया है',
Preferential:'तरजीही',
DateDay:'दिनांक',
OrderNum:'क्रम संख्या',
Name:'नाम',
UserName:'उपयोगकर्ता नाम',
IdNum:'आईडी नंबर',
BirthDay:'जन्मदिन',
SEX:'लिंग',
Female:'महिला',
Male:'पुरुष',
Select:'चुनते हैं',
Address:'पता',
Phone:'फ़ोन',
Email:'ईमेल',
CardNum:'कार्ड नंबर',
Price:'मूल्य',
QTY:'मात्रा',
SupplierCategory:'आपूर्तिकर्ता श्रेणी',
CustomerCategory:'ग्राहक श्रेणी',
Power:'शक्ति',
Role:'भूमिका',
save:'बचाना',
image:'छवि',
search:'खोज',
Year:'साल',
Month:'महीना',
Day:'दिन',
Total:'संपूर्ण',
WorkReport:'काम की रपट',
Leave:'छोड़ना',
CheckIn:'चेक इन',
Announcement:'घोषणा',
Approval:'अनुमोदन',
Tracking:'नज़र रखना',
Bill:'बिल',
OrdersDetail:'आदेश विस्तार से',
Expense:'व्यय',
Income:'आय',
Userfor:'के लिए उपयोगकर्ता',
Amount:'रकम',
Title:'शीर्षक',
News:'समाचार',
SelectFile:'फ़ाइल का चयन करें',
Content:'सामग्री',
Cost:'लागत',
ApprovalUser:'स्वीकृति उपयोगकर्ता',
ApprovalStatus:'अनुमोदन स्थिति',
ApprovalRemark:'अनुमोदन',
ApprovalDate:'स्वीकृति तिथि',
SubmitDate:'जमा करने की तारीख',
Status:'स्थिति',
FromDateTime:'दिनांक समय से',
ToDateTime:'आज तक',
Subject:'विषय',
Latitude:'अक्षांश',
Longitude:'देशान्तर',
Print:'छाप',
DataTrans:'डेटा ट्रांस',
OA:'OA',
Setting:'सेट',
Help:'मदद',
ScanOpenInPhone:'फोन में स्कैन खोलें',
Building:'इमारत',
Room:'कक्ष',
HotelCheckIn:'चेक इन',
CheckOut:'चेक आउट',
Hotel:'होटल',
Checkintime:'समय पर जांचो',
Checkouttime:'जाने का समय',
Deposit:'जमा',
Cost:'लागत',
RoomNum:'रूम नं',
Rent:'किराया',
costday:'costday',
rent:'किराया',
waternum:'पानी की डिग्री',
electricnum:'इलेक्ट्रिक डिग्री',
gasnum:'गैस डिग्री',
watercost:'पानी की लागत',
electriccost:'बिजली का खर्च',
gascost:'गैस की लागत',
cleaningcost:'सफाई का खर्च',
networkcost:'नेटवर्क लागत',
tvcost:'टीवी की लागत',
managecost:'लागत का प्रबंधन करें',
othercost:'अन्य लागत',
totalcost:'कुल लागत',
remark:'टिप्पणी',
addtime:'समय जोड़ें',
OpenInBrowser:'ब्राउज़र में खोलें',
InventoryProfit:'इन्वेंटरी लाभ',
InventoryLoss:'इन्वेंटरी नुकसान',
Buy:'खरीदें',



Refresh:'ताज़ा करें',
Add:'जोड़ें',
Search:'खोजें',
Records:'रिकॉर्ड',
}



// WEBPACK FOOTER //
// ./src/lang/hd.js